import React from "react";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Badge,
} from "reactstrap";
import moment from "moment";
import { Container as DragContainer, Draggable } from "react-smooth-dnd";
import ScheduleVisit from "./ScheduleVisit";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const BulkReservationScheduleDayLayout = ({
  schedule,
  schIndex,
  date,
  venuesLookup,
  addVisitToReservationSchedule,
  removeVisitToReservationSchedule,
  updateReservationProps,
  deleteReservationProps,
  applyDrag,
  isWithinTrip,
  zoom,
  isOldDaysEnabled,
  isBulkApplying,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "white",
        borderRadius: 5,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#aaa",
        fontSize: zoom,
      }}
    >
      <span
        style={{
          display: "flex",
          // width: "100%",
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          borderBottomColor: "#aaa",
          justifyContent: "center",
        }}
      >
        {moment(date, "YYYY-MM-DD HH:mm:ss").format("Do MMM YYYY")}
      </span>
      {schedule != null ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              marginBottom: 5,
              marginTop: 5,
            }}
          >
            {isBulkApplying ? (
              <Badge color="warning" style={{ color: "white" }}>
                <Spinner size={5} animating={true} color={"#fff"} /> Saving
              </Badge>
            ) : (
              <Badge color="success" style={{ color: "white" }}>
                Saved
              </Badge>
            )}
            {/* <Badge color="info" style={{ color: "white" }}>
              {"Score: " + schedule.schedule.score}
            </Badge> */}
          </div>
          <DragContainer
            groupName={"mainList"}
            getChildPayload={(i) => schedule.schedule.visits[i]}
            onDrop={(e) => {
              let newList = applyDrag(schedule.schedule.visits, e);

              updateReservationProps([
                {
                  prop: "reservationSchedule." + schIndex + ".schedule.visits",
                  value: newList,
                },
              ]);
            }}
            dropPlaceholder={{
              animationDuration: 150,
              showOnTop: true,
              className: "drop-preview",
            }}
            style={{ backgroundColor: "#EEE", borderRadius: 5 }}
          >
            {schedule.schedule.visits.map((visit, index) => {
              if (
                moment(date, "YYYY-MM-DD HH:mm:ss").diff(
                  moment().format("YYYY-MM-DD")
                ) < 0 &&
                !isOldDaysEnabled
              ) {
                return (
                  <ScheduleVisit
                    key={index}
                    enabled={false}
                    visit={visit}
                    schIndex={schIndex}
                    vIndex={index}
                    updateReservationProps={updateReservationProps}
                    removeVisitToReservationSchedule={
                      removeVisitToReservationSchedule
                    }
                  />
                );
              } else {
                return (
                  <Draggable key={index}>
                    <ScheduleVisit
                      enabled={true}
                      visit={visit}
                      schIndex={schIndex}
                      vIndex={index}
                      updateReservationProps={updateReservationProps}
                      removeVisitToReservationSchedule={
                        removeVisitToReservationSchedule
                      }
                    />
                  </Draggable>
                );
              }
            })}
            {moment(date, "YYYY-MM-DD HH:mm:ss").diff(
              moment().format("YYYY-MM-DD")
            ) >= 0 || isOldDaysEnabled ? (
              <ButtonDropdown
                className="mr-1"
                isOpen={schedule.schedule.isOpenDropdown}
                toggle={() => {
                  updateReservationProps([
                    {
                      prop:
                        "reservationSchedule." +
                        schIndex +
                        ".schedule.isOpenDropdown",
                      value: !schedule.schedule.isOpenDropdown,
                    },
                  ]);
                }}
                style={{ width: "100%", marginTop: 5 }}
              >
                <DropdownToggle
                  outline
                  color="success"
                  style={{ borderRadius: 5, border: 0 }}
                >
                  <i className={"fa fa-plus"} />
                </DropdownToggle>
                <DropdownMenu style={{ height: 250, overflowY: "scroll" }}>
                  {venuesLookup.data.map((item) => {
                    return (
                      <DropdownItem
                        style={{ fontSize: zoom }}
                        onClick={() => {
                          addVisitToReservationSchedule(
                            schIndex,
                            JSON.parse(JSON.stringify(item))
                          );
                        }}
                      >
                        <span>{item.name}</span>
                        <Badge color="info" style={{ color: "white" }}>
                          {item.score}
                        </Badge>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </ButtonDropdown>
            ) : null}
          </DragContainer>
        </>
      ) : isWithinTrip ? (
        // <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: 100 }}>
        //   <Button
        //     style={{ height: "90%", width: "90%" }}
        //     outline
        //     color={"faiz1"}
        //     onClick={() => {
        //       createNewReservationSchedule(
        //         moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
        //         reservation_id,
        //         calWeekIndex,
        //         calDayIndex
        //       );
        //     }}
        //     disabled={isLoading}
        //   >
        //     {isLoading ? <Spinner size={10} animating={true} color={"#c87244"} /> : <i className={"fa fa-plus"} color={"faiz1"} />}
        //     <br />
        //     <span>Make a schedule</span>
        //   </Button>
        // </div>
        <div />
      ) : (
        <div />
      )}
    </div>
  );
};

export default BulkReservationScheduleDayLayout;
